import AppLayout from "../../layouts/AppLayout";
import Card from "../../components/Card";
import InfoCard from "../../components/InfoCard";
import PrimaryButton from "../../components/PrimaryButton";
import useTradingOverview from "../../hooks/useTradingOverview";
import { useNavigate } from "react-router-dom";

function AutoTrading() {
    const navigate = useNavigate();
    const { overview, error, updatedAt, reload } = useTradingOverview(30000);
    const dashboard = overview?.dashboard;
    const candidates = overview?.candidates || [];

    const holdings = (dashboard?.balance?.holdings) || [];
    const lossRate = Number(dashboard?.balance?.totalProfitRateValue || 0);
    const enabled = Boolean(dashboard?.setting?.autoEnabled);

    return (
        <AppLayout title="자동매매 운영센터" subTitle="계좌 위험·보유 종목·후보 상태를 30초마다 갱신합니다.">
            <Card>
                <div className="operation-header">
                    <div>
                        <div className="info-title">자동매매 상태</div>
                        <div className="operation-state" style={{ color: enabled ? "#027a48" : "#b42318" }}>
                            {enabled ? "ON · 주문 가능" : "OFF · 주문 차단"}
                        </div>
                    </div>
                    <PrimaryButton text="새로고침" onClick={reload} />
                </div>
                <div className="info-sub">마지막 갱신: {updatedAt ? updatedAt.toLocaleTimeString() : "데이터 조회 중"}</div>
                {error && <div className="operation-alert">{error}</div>}
            </Card>

            <div className="metric-grid">
                <InfoCard title="계좌 손익률" value={lossRate.toFixed(2) + "%"} valueStyle={{ color: lossRate <= (overview?.emergencyStopRate || -50) ? "#b42318" : lossRate < 0 ? "#b54708" : "#027a48" }} sub={(overview?.emergencyStopRate || -50) + "% 이하에서는 시장가 청산 후 자동매매 OFF"} />
                <InfoCard title="보유 종목" value={holdings.length + " / " + (overview?.maxPositionCount || 5)} sub="보유·미체결 통합 한도" />
            </div>

            <Card>
                <div className="card-title">주문 대기 상태</div>
                <div className="operation-row"><span>분석 완료 후보</span><strong>{candidates.length}개</strong></div>
                <div className="operation-row"><span>신규 매수 판단</span><strong>장중 눌림목 신호 재확인</strong></div>
                <div className="operation-row"><span>후보 상세 분석</span><button className="text-action" onClick={() => navigate("/stock")}>종목 탭으로 이동</button></div>
            </Card>

            <Card>
                <div className="card-title">운영 점검</div>
                <div className="check-row">✓ 신규 주문 전 눌림목 신호를 재확인합니다.</div>
                <div className="check-row">✓ 손절 조건은 시장가 매도로 우선 체결을 시도합니다.</div>
                <div className="check-row">✓ 계좌 손실 -50% 도달 시 긴급 청산 절차가 실행됩니다.</div>
            </Card>
        </AppLayout>
    );
}

export default AutoTrading;
